import { i18nManager } from 'oasis-os-common';
import { ContentfulApp } from '../types';
import { getDefaultLocaleObj } from './getDefaultLocaleObj';
import { setCookie } from 'oasis-os-utils';
import { readGlobal } from 'oasis-os-common';

export enum Lang {
  init = 'init',
  change = 'change',
}
export default function handleLocalization(
  locLib: Lang,
  defaultLocale: string,
  configs: ContentfulApp,
  setIsLocalized: React.Dispatch<React.SetStateAction<boolean>>,
) {
  const { fields: appConfig } = configs;
  const locale = appConfig?.locale || [];
  if (locale?.length && defaultLocale) {
    const localeValue = defaultLocale.replace('_', '-');
    const url = (getDefaultLocaleObj(locale, localeValue) || getDefaultLocaleObj(locale, readGlobal('$.global.value.functionalConfig.i18n.defaultLocale')))
      ?.fields?.file?.url;
    setCookie('defaultLocale', defaultLocale, 365);
    if (url) {
      fetch(url)
        .then((response) => response.json())
        .then((data: string) => {
          if (locLib === Lang.init) {
            i18nManager.init({
              lng: localeValue,
              translation: data,
            });
          } else if (locLib === Lang.change) {
            i18nManager.addResourceBundle(localeValue, data);
            i18nManager.changeLanguage(localeValue);
          }
          setIsLocalized(true);
        })
        .catch((_) => {
          throw new Error('Localization Setup Failed.');
        });
    } else {
      throw new Error('Localization Setup Failed. No URL Found.');
    }
  } else {
    throw new Error('Localization Setup Failed Default Locale Is not found!');
  }
}
